/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortOrder = {
  Descending: 'Descending',
  Ascending: 'Ascending',
} as const;
